import React from 'react';
import { Button, Text } from 'pp-react';

import content from '../lib/i18n';
import * as analytics from '../lib/analytics';

const i18n = content('hub/components/faqbanner');

const FAQBanner = ({ fptiInfo }) => {
  return (
    <div className='faq-banner'>
      <Text as='div' size='xl' className='faq-banner-label'>
        {i18n('label.banner')}
      </Text>
      <Button
        onClick={() => {
          if (fptiInfo) {
            analytics.trackLinkWithData(
              'FAQBanner',
              fptiInfo.pgrp,
              fptiInfo.page,
              {},
              'link'
            );
          }
        }}
        as='a'
        target='_blank'
        href={i18n('label.href')}
        data-testid='faq-banner-button'
        size='md'
        secondary
      >
        {i18n('label.button')}
      </Button>
    </div>
  );
};

export default FAQBanner;
